import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { ProductSegment } from '../shared/models/product-segment.enum';
import { UserService } from '../shared/services/user/user.service';

@Injectable()
export class StockResolveGuard {
  constructor(
    private userService: UserService,
    private router: Router
  ) {}

  resolve(
    /* eslint-disable @typescript-eslint/no-unused-vars */
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
    /* eslint-enable @typescript-eslint/no-unused-vars */
  ): Observable<any> | Promise<any> | any {
    if (!this.userService.userHasSegment(ProductSegment.Stock)) {
      this.router.navigate(['/dashboard']);
      return Promise.resolve(false);
    }

    return Promise.resolve(true);
  }
}
